const H = {
  name: "Hashtag",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.28 7L11.78 9H13.72L14.22 7H16.28L15.78 9H17V11H15.28L14.78 13H17V15H14.28L13.78 17H11.72L12.22 15H10.28L9.77997 17H7.71997L8.21997 15H7V13H8.71997L9.21997 11H7V9H9.71997L10.22 7H12.28ZM10.78 13H12.72L13.22 11H11.28L10.78 13Z" fill="currentColor"/>
<path d="M2 5C2 3.34772 3.34772 2 5 2H19C20.6523 2 22 3.34772 22 5V19C22 20.6523 20.6523 22 19 22H5C3.34772 22 2 20.6523 2 19V5ZM5 4C4.45228 4 4 4.45228 4 5V19C4 19.5477 4.45228 20 5 20H19C19.5477 20 20 19.5477 20 19V5C20 4.45228 19.5477 4 19 4H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Hashtag
};
